<template>
  <VDialog
    ref="dialog"
    @action="$emit('update-action', $event), $emit('before-close'), $emit('close')"
  >
    <slot />

    <template #close-btn>
      <slot name="close-btn" />
    </template>

    <template #content-in-mask>
      <slot name="content-in-mask" />
    </template>
  </VDialog>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import VDialog from '../../dialog/src/main.vue'
import '../../dialog/src/dialog-common.less'

export default {
  name: 'VDialogBox',
  components: { VDialog },
  model: {
    prop: 'visible',
    event: 'close'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    // footer 按钮方向，默认水平
    direction: {
      type: String,
      default: 'horizontal'
    },
    confirmButtonText: {
      type: String,
      default: 'OK'
    },
    cancelButtonText: {
      type: String,
      default: 'CANCEL'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    dangerouslyUseHTMLString: {
      type: Boolean,
      default: false
    },
    distinguishCancelAndClose: {
      type: Boolean,
      default: false
    },
    // 是否可通过点击遮罩关闭
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    // 出现3个以上自定义按钮时配置
    moreButtonText: {
      type: Array,
      default: () => []
    },
    // dialog max width
    maxWidth: {
      type: String,
      default: ''
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const dialog = ref()

    watchEffect(() => {
      if (dialog.value) {
        const { value } = dialog
        const {
          visible,
          title,
          message,
          action,
          direction,
          confirmButtonText,
          cancelButtonText,
          showClose,
          showFooter,
          dangerouslyUseHTMLString,
          distinguishCancelAndClose,
          closeOnClickModal,
          maxWidth,
          noMargin
        } = props
        value.box = true
        value.visible = visible
        value.title = title
        value.message = message
        value.action = action
        value.direction = direction
        value.confirmButtonText = confirmButtonText
        value.cancelButtonText = cancelButtonText
        value.showClose = showClose
        value.showFooter = showFooter
        value.dangerouslyUseHTMLString = dangerouslyUseHTMLString
        value.distinguishCancelAndClose = distinguishCancelAndClose
        value.closeOnClickModal = closeOnClickModal
        value.maxWidth = maxWidth
        value.noMargin = noMargin
      }
    })

    return { dialog }
  },
  methods: {
    handleWrapperClick() {
      this.$ref.dialog.handleWrapperClick()
    },
    handleAction(action) {
      this.$ref.dialog.handleAction(action)
    },
    handleClose() {
      this.$ref.dialog.handleAction('close')
    }
  }
}
</script>
